const LIST_ITEM_CLASSNAME = "list-item", SELECTED_CLASSNAME = "item-selected";
export {
  LIST_ITEM_CLASSNAME,
  SELECTED_CLASSNAME
};
//# sourceMappingURL=constants.js.map
